import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'dealstore_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = (choice) => {
    setLeaving(true);
    localStorage.setItem(COOKIE_KEY, choice);
    setTimeout(() => setVisible(false), 350);
  };

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes cookie-pop-in {
          from { transform: translate(-50%, -50%) scale(0.85); opacity: 0; }
          to   { transform: translate(-50%, -50%) scale(1);    opacity: 1; }
        }
        @keyframes cookie-pop-out {
          from { transform: translate(-50%, -50%) scale(1);    opacity: 1; }
          to   { transform: translate(-50%, -50%) scale(0.85); opacity: 0; }
        }
        .cookie-banner {
          animation: cookie-pop-in 0.35s cubic-bezier(0.34,1.56,0.64,1) both;
        }
        .cookie-banner.leaving {
          animation: cookie-pop-out 0.25s ease-in both;
        }
      `}</style>

      <div
        className={`cookie-banner${leaving ? ' leaving' : ''}`}
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'calc(100% - 32px)',
          maxWidth: '420px',
          zIndex: 9998,
          borderRadius: '20px',
          background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
          border: '1px solid rgba(255,255,255,0.1)',
          boxShadow: '0 -4px 40px rgba(0,0,0,0.4), 0 8px 32px rgba(0,0,0,0.3)',
          padding: '20px',
          color: '#fff',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
          <span style={{ fontSize: '26px', lineHeight: 1 }}>🍪</span>
          <div>
            <p style={{ fontWeight: 700, fontSize: '15px', margin: 0, color: '#fff' }}>
              We use Cookies
            </p>
            <p style={{ fontSize: '11px', margin: 0, color: 'rgba(255,255,255,0.45)', letterSpacing: '0.04em' }}>
              For a better experience
            </p>
          </div>
          <button
            onClick={() => dismiss('dismissed')}
            style={{
              marginLeft: 'auto',
              background: 'rgba(255,255,255,0.08)',
              border: 'none',
              borderRadius: '50%',
              width: 28,
              height: 28,
              cursor: 'pointer',
              color: 'rgba(255,255,255,0.5)',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <p style={{
          fontSize: '12.5px',
          color: 'rgba(255,255,255,0.65)',
          lineHeight: 1.6,
          margin: '0 0 16px 0',
        }}>
          We use cookies to personalise content, remember your preferences, and improve your shopping experience. Your data stays safe with us.
        </p>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={() => dismiss('accepted')}
            style={{
              flex: 1,
              padding: '10px',
              border: 'none',
              borderRadius: '12px',
              fontWeight: 700,
              fontSize: '13px',
              cursor: 'pointer',
              color: '#fff',
              background: 'linear-gradient(90deg, #2563eb, #4f46e5)',
              boxShadow: '0 4px 14px rgba(37,99,235,0.4)',
              transition: 'opacity 0.15s',
            }}
          >
            ✓ Accept All
          </button>
          <button
            onClick={() => dismiss('rejected')}
            style={{
              flex: 1,
              padding: '10px',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: '12px',
              fontWeight: 600,
              fontSize: '13px',
              cursor: 'pointer',
              color: 'rgba(255,255,255,0.7)',
              background: 'rgba(255,255,255,0.06)',
              transition: 'opacity 0.15s',
            }}
          >
            Decline
          </button>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
